import { FC } from 'react';

export const WalletActionProcess: FC<{ title: string }> = ({ title }) => (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-walletConnectBlur px-2">
    <div
      className="relative min-w-[448px] rounded-lg border border-b-4 border-black bg-popupBackground p-6 text-center shadow-lg"
    >
      <h1 className="text-xl font-bold uppercase text-white">{title}</h1>
      <span className="loader mx-auto mt-4 block" />

    </div>
  </div>
);
